/**
 * Sprint selectors
 */

import { RootState } from "types";

import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./initialState";

const selectDomain = (state: RootState) => state?.sprintState || initialState;

export const selectSettingDrawerOpen = createSelector(
  [selectDomain],
  (state) => state.settingDrawerOpen,
);
export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading,
);
export const selectButtonLoading = createSelector(
  [selectDomain],
  (state) => state.buttonLoading,
);
export const selectSprintList = createSelector(
  [selectDomain],
  (state) => state.list,
);
export const selectSprintFilter = createSelector(
  [selectDomain],
  (state) => state.filters,
);
export const selectCustomizeTableHeader = createSelector(
  [selectDomain],
  (state) => state.customizeHeader,
);
export const selectPagination = createSelector(
  [selectDomain],
  (state) => state.pagination,
);
export const selectHasMore = createSelector(
  [selectPagination],
  (state) => state.page < state.totalPage,
);
export const selectSprintFormDta = createSelector(
  [selectDomain],
  (state) => state.formData,
);
export const selectCompletedSprintList = createSelector(
  [selectDomain],
  (state) => state.completedSprintList,
);
export const selectMainLoading = createSelector(
  [selectDomain],
  (state) => state.mainLoading,
);
export const selectSprintDetailDrawer = createSelector(
  [selectDomain],
  (state) => state.sprintDetailDrawer,
);
export const selectSelectedSprintId= createSelector(
  [selectDomain],
  (state) => state.selectedSprintId,
);
